import { V_FORM_ENUM } from '@/CommonDP/VForm/utils';
import component from "./index.vue";
export const schema = {
  component,
  group: V_FORM_ENUM.custom,
  type: 'jy-folder-list',
  icon: 'vue-sfc',
  formItemFlag: true,
  label: '关联文档',
  props() {
    return {
      setting: () => import('./setting.vue')
    };
  },
  options: {
    name: '',
    label: '关联文档',
    labelAlign: '',
    columnWidth: '300px',
    labelWidth: null,
    labelHidden: false,
    labelWrap: false, // 自动换行
    disabled: false,
    hidden: false,
    // -------------------
    setting: '',
    prjRoot: "",
    prjRootModule: '',
    prjRootName: ""
  }
};
